import React, { useEffect, useMemo, useState } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { styles } from './styles';
import { EmptyFileBoxProps } from './types';

const EmptyFileBox = ({ requestedFile, handleUploadFiles, loadingFiles, progress }: EmptyFileBoxProps) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (requestedFile.id) {
      setIsLoading(loadingFiles[requestedFile.id] || false);
    }
  }, [loadingFiles, requestedFile.id]);

  const isLoadingMemo = useMemo(() => isLoading, [isLoading]);

  return (
    <Box border={1} borderRadius={4} borderColor="#FFFFFF" p={2} mb={1} style={styles.container}>
      <Box display="flex" alignItems="center">
        <svg style={styles.svg} viewBox="0 0 32 38" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M17.0168 33.6667H4.00008C2.15008 33.6667 0.666748 32.1833 0.666748 30.3333V3.66666C0.666748 2.78261 1.01794 1.93476 1.64306 1.30964C2.26818 0.684518 3.11603 0.333328 4.00008 0.333328H17.3334L27.3334 10.3333V18.8167C26.7834 18.7333 26.2334 18.6667 25.6667 18.6667C25.1001 18.6667 24.5501 18.7333 24.0001 18.8167V12H15.6667V3.66666H4.00008V30.3333H15.8167C16.0167 31.5333 16.4334 32.65 17.0168 33.6667ZM32.3334 27H27.3334V22H24.0001V27H19.0001V30.3333H24.0001V35.3333H27.3334V30.3333H32.3334V27Z"
            fill="#043A6E"
          />
        </svg>
        <Box flexGrow={1} ml="3rem">
          <Typography style={styles.fileName}>{requestedFile.name}</Typography>
        </Box>
        {isLoadingMemo ? (
          <CircularProgress size={24} />
        ) : (
          <Button variant="outlined" component="label" style={styles.uploadButton}>
            Upload
            <input
              type="file"
              style={styles.hiddenInput}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleUploadFiles(event, requestedFile.id)}
              multiple
            />
          </Button>
        )}
      </Box>
      {isLoadingMemo && (
        <Box width="100%" mt={1}>
          <Typography variant="body2" color="textSecondary">{`Upload progress: ${progress}%`}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default EmptyFileBox;
